export const coreWalletBalanceTransactionStatusForSelection = [
	'Created',
	'Reserved',
	'Cancelled',
	'Completed'
].map(status => {
	return {
		id: status,
		name: status
	};
});
